<template>
  <div class="container">
    <h1 class="py-4">決済手段データ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">ウォレットサービスID</label><br />
          <input
            v-model="walletServiceId"
            placeholder="ウォレットサービスID"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">ウォレットサービス名</label><br />
          <input
            v-model="walletServiceName"
            placeholder="ウォレットサービス名"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">アプリユーザID</label><br />
          <input
            v-model="applicationUserId"
            placeholder="アプリユーザID"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">決済手段ID</label><br />
          <input
            v-model="paymentMethodId"
            placeholder="決済手段ID"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">契約番号</label><br />
          <input
            v-model="contractNumber"
            placeholder="契約番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">決済サービス</label><br />
          <input
            v-model="paymentService"
            placeholder="決済サービス"
            class="input-boot"
          />
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #head(ウォレットサービスID)="data">
            <div class="minWidth160">{{ data.label }}</div>
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "PaymentMethod",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      applicationUserId: "",
      walletServiceId: "",
      walletServiceName: "",
      paymentMethodId: "",
      contractNumber: "",
      paymentService: "",
      key: 0,
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.labels = this.tsvFormat.bankitInfo.labels;
    this.loadCollection();
  },
  methods: {
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    englishField(fieldNameJp) {
      return this.fields[fieldNameJp];
    },
    clear() {
      this.applicationUserId = "";
      this.walletServiceId = "";
      this.walletServiceName = "";
      this.paymentMethodId = "";
      this.contractNumber = "";
      this.paymentService = "";
      this.init();
      this.loadCollection();
    },
    search() {
      let searchParams = {
        application_user_id: this.applicationUserId,
        wallet_service_id: this.walletServiceId,
        wallet_service_name: this.walletServiceName,
        payment_method_id: this.paymentMethodId,
        contract_number: this.contractNumber,
        payment_service: this.paymentService,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      this.loading = true;

      let query = this.db.collection("paymentMethod");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      // query.orderBy("contract_number", "asc");
      this.fileName = this.tsvFormat.paymentMethodData.fileName;
      this.csvCurrentFields = this.tsvFormat.paymentMethodData.labels;
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              this.tableData.push({
                ウォレットサービスID: data.wallet_service_id,
                ウォレットサービス名: data.wallet_service_name.trim(),
                アプリユーザID: data.application_user_id,
                決済手段ID: data.payment_method_id,
                契約番号: data.contract_number,
                決済サービス: data.payment_service,
                作成日時: data.created_at,
                最終更新日時: data.updated_at,
              });
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
